var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgJcb = function SvgJcb(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 18.0833,
    transform: "translate(0 1)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5671 15.3342C27.5671 17.3585 25.9264 19 23.9014 19H4V4.50995C4 2.48511 5.64075 0.843628 7.66599 0.843628H27.5671L27.5671 15.3342Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0794 10.2402C21.6478 10.2526 22.2195 10.2151 22.7857 10.2597C23.3591 10.3666 23.4972 11.2346 22.9879 11.5189C22.6403 11.7062 22.2274 11.5887 21.8506 11.6217H21.0794V10.2402ZM23.1143 8.67656C23.2406 9.12233 22.8109 9.52257 22.3816 9.46118H21.0794C21.0885 9.0408 21.0615 8.58452 21.0927 8.18628C21.6143 8.20097 22.1408 8.15631 22.6594 8.20963C22.8822 8.26562 23.0687 8.44881 23.1143 8.67656ZM26.2482 2.06573C26.2724 2.91704 26.2517 3.81335 26.2587 4.68193C26.2571 8.21328 26.2621 11.7448 26.2559 15.276C26.2331 16.5995 25.0601 17.7494 23.7459 17.7758C22.4303 17.7812 21.1146 17.7766 19.7988 17.7781V12.4394C21.2324 12.432 22.6667 12.4544 24.0997 12.4282C24.7644 12.3865 25.4926 11.9478 25.5235 11.2163C25.6018 10.4816 24.9091 9.9734 24.2514 9.89314C23.9986 9.88657 24.006 9.81944 24.2514 9.79016C24.8787 9.65459 25.3712 9.00539 25.1867 8.35522C25.0294 7.67138 24.2736 7.40671 23.6449 7.40803C22.363 7.39932 21.0809 7.40681 19.799 7.40428C19.8073 6.40762 19.7817 5.40989 19.8127 4.41396C19.9143 3.11439 21.1167 2.04267 22.4126 2.06592C23.6913 2.06578 24.9698 2.06578 26.2482 2.06573Z",
    fill: "url(#paint0_linear_3684_42204)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.31339 4.54867C5.34613 3.22732 6.52404 2.08677 7.83664 2.06745C9.14735 2.06342 10.4582 2.06687 11.769 2.0657C11.7654 6.48669 11.7761 10.908 11.7636 15.3288C11.7131 16.6341 10.548 17.7529 9.24969 17.776C7.93651 17.7807 6.62317 17.7767 5.30994 17.778V12.2592C6.58552 12.5605 7.92318 12.6888 9.2245 12.4889C10.0024 12.3637 10.8534 11.9818 11.1168 11.1748C11.3106 10.4845 11.2015 9.75798 11.2303 9.04948V7.40411H8.97826C8.96814 8.49232 8.99898 9.58243 8.96197 10.6693C8.90126 11.3374 8.23965 11.7619 7.60957 11.7392C6.82816 11.7475 5.27968 11.1729 5.27968 11.1729C5.27579 9.13403 5.30235 6.58067 5.31339 4.54867Z",
    fill: "url(#paint1_linear_3684_42204)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6075 8.06807C12.489 8.09322 12.5836 7.66428 12.5533 7.50156C12.5614 6.47275 12.5365 5.44282 12.5671 4.41473C12.6684 3.10967 13.8801 2.03527 15.1811 2.06582H19.0127C19.0091 6.48681 19.0197 10.908 19.0073 15.3289C18.9567 16.6342 17.7916 17.7529 16.4933 17.7761C15.18 17.781 13.8666 17.7768 12.5533 17.7781V11.7318C13.4503 12.4677 14.6693 12.5823 15.7867 12.5842C16.6291 12.584 17.4666 12.4541 18.2847 12.2598V11.1521C17.3628 11.6116 16.2789 11.9034 15.2569 11.6394C14.544 11.4619 14.0265 10.773 14.0381 10.0373C13.9555 9.27215 14.404 8.46437 15.1558 8.23691C16.0894 7.94466 17.1068 8.16818 17.9819 8.54813C18.1694 8.6463 18.3596 8.76805 18.2847 8.45469V7.58401C16.8212 7.23582 15.2637 7.1077 13.7934 7.48648C13.3678 7.60654 12.9532 7.78861 12.6075 8.06807Z",
    fill: "url(#paint2_linear_3684_42204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3684_42204",
    x1: 19.799,
    y1: 9.93148,
    x2: 26.2625,
    y2: 9.93148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007B40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3684_42204",
    x1: 5.32413,
    y1: 9.91665,
    x2: 11.7712,
    y2: 9.91665,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2970"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3684_42204",
    x1: 12.5445,
    y1: 9.93129,
    x2: 19.003,
    y2: 9.93129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E2B2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgJcb);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "jcb.fd2389530918474c18b033c3ff81b14e.svg";